import { render, staticRenderFns } from "./rdaccount-add-or-update.vue?vue&type=template&id=2ac2e215&"
import script from "./rdaccount-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rdaccount-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports